module.exports = __webpack_public_path__ + "img/like.bc5eda92.png";